"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pauseObservability = exports.InternalLoggerLevel = exports.LogLevel = exports.pushMeasurement = exports.pushLog = exports.pushEvent = exports.pushError = exports.setUserAttributes = exports.setUser = exports.initObservability = void 0;
const tslib_1 = require("tslib");
const faro_web_sdk_1 = require("@grafana/faro-web-sdk");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return faro_web_sdk_1.LogLevel; } });
Object.defineProperty(exports, "InternalLoggerLevel", { enumerable: true, get: function () { return faro_web_sdk_1.InternalLoggerLevel; } });
const initObservability_1 = tslib_1.__importDefault(require("./api/initObservability"));
exports.initObservability = initObservability_1.default;
const setUser_1 = tslib_1.__importDefault(require("./api/setUser"));
exports.setUser = setUser_1.default;
const setUserAttributes_1 = tslib_1.__importDefault(require("./api/setUserAttributes"));
exports.setUserAttributes = setUserAttributes_1.default;
const push_1 = require("./api/push");
Object.defineProperty(exports, "pushError", { enumerable: true, get: function () { return push_1.pushError; } });
Object.defineProperty(exports, "pushEvent", { enumerable: true, get: function () { return push_1.pushEvent; } });
Object.defineProperty(exports, "pushLog", { enumerable: true, get: function () { return push_1.pushLog; } });
Object.defineProperty(exports, "pushMeasurement", { enumerable: true, get: function () { return push_1.pushMeasurement; } });
const pauseObservability_1 = tslib_1.__importDefault(require("./api/pauseObservability"));
exports.pauseObservability = pauseObservability_1.default;
//# sourceMappingURL=index.js.map